import React from 'react'
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon'

export default createSvgIcon(
  <React.Fragment>
    <path d="M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </React.Fragment>
, "Apps")


// WEBPACK FOOTER //
// ../../src/AppsIcon/AppsIcon.js